import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
// import router from '@/router'

Vue.use(Vuex)

// const mainurl = 'http://192.168.1.105:8000';
const mainurl = 'https://appapi.akambc.com';

let state = {
    factors: [],
}
const mutations = {
    nothing(){},

    factor_list(state , factors){
        Vue.set(state, 'factors', factors);
        Vue.set(state, 'factors', [...factors]);
    },

    add_factor(state, factor){
        state.factors.unshift(factor)
    },

    edit_factor(state, payload){
        const item = state.factors.find(item => item.id === payload.id);
        Object.assign(item, payload);
    },

    delete_factor(state, id){
        const itemIndex = state.factors.findIndex(item => item.id === id);
        state.factors.splice(itemIndex , 1);
    },

}
const actions = {
    getFactors({ dispatch, commit }, info){
        let query = ''
        if(info.title != ''){
            query = `/${info.status}/${info.title}?page=${info.page}`
        }
        else {
            query = `/${info.status}?page=${info.page}`
        }
        return new Promise((resolve,reject) => {
            axios({ url: `${mainurl}/api/admin/factors/${info.type}${query}`, method: 'GET'})
            .then(res => {
                commit('factor_list', res.data.data)
                resolve(res)
            })
            .catch(err => {
                if (err.response.status === 401) {
                    dispatch('goLogin')
                  }
                reject(err)
            })
        })
    },

    getFactorInfo({ dispatch, commit }, id){
        commit('nothing')
        return new Promise((resolve,reject) => {
            axios({ url: `${mainurl}/api/admin/factor/${id}`, method: 'GET' })
            .then(res => {
                resolve(res)
            })
            .catch(err => {
                if (err.response.status === 401) {
                    dispatch('goLogin')
                }
                reject(err)
            })
        })
    },

    addFactor({ dispatch, commit }, payload){
        return new Promise((resolve,reject) => {
            axios({ url: `${mainurl}/api/admin/newFactor`, data: payload, method: 'POST' })
            .then(res => {
                commit("nothing")
                // commit('add_order', res.data.data)
                // commit("addMessage" , res.data[0].fields)
                resolve(res)
            })
            .catch(err => {
                if (err.response.status === 401) {
                    dispatch('goLogin')
                }
                reject(err)
            })
        })
    },

    updateFactorInfo({ dispatch, commit }, payload){
        return new Promise((resolve,reject) => {
            axios({ url: `${mainurl}/api/admin/editFactor/${payload.id}`, data: payload, method: 'POST' })
            .then(res => {
                commit('edit_factor', payload)
                resolve(res)
            })
            .catch(err => {
                if (err.response.status === 401) {
                    dispatch('goLogin')
                }
                reject(err)
            })
        })
    },

    deleteFactor({ dispatch, commit }, id){
        return new Promise((resolve,reject) => {
            axios({ url: `${mainurl}/api/admin/deleteFactor/${id}`, method: 'DELETE' })
            .then(res => {
                commit('delete_factor' , id)
                resolve(res)
            })
            .catch(err => {
                if (err.response.status === 401) {
                    dispatch('goLogin')
                }
                reject(err)
            })
        })
    }
}
const modules = {

}
const getters = {
}
export default({
    state,
    mutations,
    actions,
    getters,
    modules,
    axios
})
